"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.langDefinition = void 0;
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.langDefinition = (0, firestore_1.defineCollection)({
    collectionName: "lang",
    idKey: "langId",
    parent: project_1.projectDefinition,
    constraints: ["projectId"],
    queryDefs: {
        list: ({ projectId, condition, }) => {
            return {
                constraint: { projectId },
                queryParams: {
                // orderBy: [["createdAt", "desc"]],
                },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
